const al = {
  minimumValue: 'Vlera minimale',
  search: 'Kërko...',
  goToCheckout: 'Shkoni në shportë',
  pleaseWait: 'Ju lutem prisni...',
  orderCreatedSuccessfully: 'Porosia u krijua me sukses!',
  checkout: 'Shporta',
  addressDetails: 'Detajet e adresës',
  phoneNumber: "Numri i telefonit",
  orderDetails: "Detajet e porosisë",
  paymentMethod: "Mënyra e pagesës",
  cash: "Para në dorë",
  subtotal: "Nëntotali",
  deliveryCharge: "Tarifa e dorëzimit",
  total: "Totali",
  verificationCodeWasNotCorrect: "Kodi i verifikimit nuk ishte i saktë",
  confirmationCode: "Kodi i verifikimit",
  enterThe4DigitCodeThatWeSentViaSMS: "Vendosni kodin 4-shifror që kemi dërguar me SMS",
  close: "Mbyll",
  enterAddress: "Vendosni adresën",
  enterYourDesiredDeliveryAddress: "Vendosni adresën tuaj të dëshiruar të dorëzimit",
  youNeedADeliveryAddressToProceed: "You need a delivery address to proceed",
  setAddress: "Vendos adresën",
  allowLocationPermissionToBrowserFromMobileSettingsForThisFunctionality: "Jepini të drejta browser-it nga settings e celularit për këtë funksionalitet.",
  geolocationIsNotSupportedInThisBrowser: "GeoLocation nuk suportohet në këtë browser",
  searchAddress: "Kërko adresë",
  deliveryAddress: "Adresa e dorëzimit",
  weAreNotAbleToCompleteYourOrderProcess: "Ne nuk jemi në gjendje të përfundojmë procesin e porosisë tuaj",
  pleaseTryAgainWhenServiceIsSupported: "Ju lutemi provoni përsëri kur shërbimi të mbështetet.",
  thankYouForYourOrder: "Faleminderit për porosinë",
  invoiceDate: "Data e faturës",
  accepted: "Pranuar",
  cancelled: "Anulluar",
  requested: "Kërkuar",
  delivering: "Në dorëzim",
  paymentInProgress: "Pagesa në vazhdim",
  waitingForConfirmation: "Në pritje të konfimimit",
  orderId: "Id e porosisë",
  restaurant: "Restoranti",
  address: "Adresa",
  orderAgain: "Porosit përsëri",
  openHours: "Hapur në",
  placeYourOrder: "Porosit",
  errors: {
    empty_delivery_address: "Adresa e dorëzimit nuk mund të jetë bosh.",
    empty_phone_number: "Numri i telefonit nuk mund të jetë bosh",
    invalid_phone_number: "Numri i telefonit nuk është valid"
  },
  table: "Tavolina",
  refresh: "Rifresko",
  inOrderToCheckAvailabilityOfFunctionalityAndProceedWithMenu: "Në mënyrë që të kontrolloni disponueshmërinë e funksionalitetit dhe të vazhdoni me menunë",
  weWereNotAbleToCompleteYourOrderProcess: "Nuk mundëm të përfundonim procesin e porosisë tuaj",
  clientMustBeInsideDefinedZones: "Klienti duhet të jetë brenda zonave të përcaktuara",
  pleaseTryAgainWhenVisitingOurBusiness: "Ju lutemi provoni përsëri kur vizitoni biznesin tonë",
  theProvidedQrIsInvalid: "QR e dhënë është e pavlefshme",
  leaveAReview: 'Pershtypjet tuaja'
};

export default al;
